import { render, staticRenderFns } from "./ReturnCapture.vue?vue&type=template&id=3b344d96&scoped=true&"
import script from "./ReturnCapture.vue?vue&type=script&lang=js&"
export * from "./ReturnCapture.vue?vue&type=script&lang=js&"
import style0 from "./ReturnCapture.vue?vue&type=style&index=0&id=3b344d96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b344d96",
  null
  
)

export default component.exports